import { APP_CONTEXTS, IRootState } from "app/model"
import { CAMPAIGN_STATUSES } from "campaign/model"
import { IFormError } from "form/model"
import React from "react"
import { connect } from "react-redux"
import { SummaryPage } from "./summary/SummaryPage"

interface ISummaryDspDealPagePageProps {
  context: APP_CONTEXTS | null
  isLoading: boolean
  error: IFormError
  inStoreCampaignId: number
  statusId: CAMPAIGN_STATUSES | null
  contentWidth: number
}

const SummaryDspDealPagePageFn = React.memo(
  ({
    context,
    isLoading,
    error,
    inStoreCampaignId,
    statusId,
    contentWidth
  }: ISummaryDspDealPagePageProps): JSX.Element => (
    <SummaryPage
      context={context}
      error={error}
      inStoreCampaignId={inStoreCampaignId}
      isLoading={isLoading}
      isForecast={false}
      isDspDeal
      statusId={statusId}
      contentWidth={contentWidth}
    />
  )
)

export const SummaryDspDealPage = connect((state: IRootState): ISummaryDspDealPagePageProps => {
  const activeContext = state.app.activeContext
  const isLoading = state.form.dspDealEditForm.isLoading
  return {
    context: activeContext,
    isLoading,
    error: state.form.dspDealEditForm.error,
    inStoreCampaignId: state.form.dspDealEditForm.form.campaignId,
    statusId: activeContext && !isLoading ? state.form.dspDealEditForm.form.statusId : null,
    contentWidth: state.ui.contentWidth
  }
})(SummaryDspDealPagePageFn)
